import _ from 'lodash';
import Promise from 'bluebird';

import getHelpers from '../helpers';
const api = getHelpers({})('api');

// initial state
const state = {
    ...window.store,
    // clinicians: [],
    currentDHBClinicians: [],
    currentPatient: null,
    currentPatientAssessments: [],
    currentPatientClinicians: [],
    currentPatientComments: [],
    currentPatientConditions: [],
    currentPatientPrescriptions: [],
    timestamp: Date.now(),
}

// getters
const getters = {
    // dHBs: (state) => state.dHBs,
    clinicians: (state) => {return state.clinicians},
    authClinician: (state) => state.authClinician,
    patientStatuses: (state) => state.patientStatuses,
    currentPatient: (state) => state.currentPatient,
    currentPatientAssessments: (state) => state.currentPatientAssessments,
    currentPatientClinicians: (state) => state.currentPatientClinicians,
    currentPatientComments: (state) => state.currentPatientComments,
    currentPatientConditions: (state) => state.currentPatientConditions,
    currentPatientPrescriptions: (state) => state.currentPatientPrescriptions,
    timestamp: (state) => state.timestamp,
    route: (state) => (name, params) => {
        let path = '/' + _.get(state, ['routes', name]);

        _.forEach(params, (value, key) => {
            path = _.replace(path, new RegExp(`{${key}[?]?}`), value);
        })

        return path;
    }
}

const actions = {
    updateCurrentPatient(context, payload){
        context.commit('updateCurrentPatient', payload);
    },
    getPatient(context , payload) {
        return api.getData(`/patient_details/${payload.NHINumber}/${payload.PDType}`, {

        }).then(res => {
            context.commit('updateCurrentPatient', res.data);
            return res;
        });
    },
    updateCurrentPatientConditions(context, payload){
        context.commit('updateCurrentPatientConditions', payload);
    },
    updateCurrentPatientPrescriptions(context, payload){
        context.commit('updateCurrentPatientPrescriptions', payload);
    },
    updateCurrentPatientAssessments(context, payload){
        context.commit('updateCurrentPatientAssessments', payload);
    },
    updateCurrentPatientComments(context, payload){
        context.commit('updateCurrentPatientComments', payload);
    },
    updateCurrentPatientClinicians(context, payload){
        context.commit('updateCurrentPatientClinicians', payload);
    },
    updateCurrentClinicians(context, payload){
        context.commit('updateCurrentClinicians', payload);
    },
}

// mutations
const mutations = {

    addNotification(state, payload) {
        _.set(state, 'notifications', _.concat(state.notifications, [payload]));
    },
    updateCurrentPatient(state, payload) {
        _.set(state, 'currentPatient', payload);
        _.set(state, 'timestamp', Date.now());
    },
    updateCurrentPatientConditions(state, payload) {
        state.timestamp = Date.now();
        _.set(state, 'currentPatientConditions', payload);
    },
    updateCurrentPatientPrescriptions(state, payload) {
        state.timestamp = Date.now();
        _.set(state, 'currentPatientPrescriptions', payload);
    },
    updateCurrentPatientAssessments(state, payload) {
        state.timestamp = Date.now();
        _.set(state, 'currentPatientAssessments', payload);
    },
    updateCurrentPatientComments(state, payload) {
        state.timestamp = Date.now();
        _.set(state, 'currentPatientComments', payload);
    },
    updateCurrentPatientClinicians(state, payload) {
        state.timestamp = Date.now();
        _.set(state, 'currentPatientClinicians', payload);
    },
    updateCurrentClinicians(state, payload) {
        state.timestamp = Date.now();
        _.set(state, 'clinicians', payload);
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
